module.exports = __webpack_public_path__ + "static/img/hussar_develop_face.aa46eac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentPage/hussar_develop_face.png
// module id = QNgn
// module chunks = 0